import React, { useState } from 'react';
import PopOver from '../components/deprecated/PopOver';
import SVGIcon from '../components/SVGIcon';
import overflowMenuIcon from '../icons/overflowMenu.svg';
import SidebarNavItem from './SidebarNavItem';
import SidebarSettings from './SidebarSettings';
import styles from './SidebarSettingsNavItem.module.scss';

const SidebarSettingsNavItem = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [open, setOpen] = useState(false);

  return (
    // @ts-expect-error
    <PopOver
      placement="right-start"
      popOver={<SidebarSettings close={() => setOpen(false)} />}
      popOverPortal={document.body}
      trigger="click"
      preventCloseOnContentClick
      open={open}
      onOpenChange={setOpen}
    >
      <SidebarNavItem
        icon={<SVGIcon className={styles.moreIcon}>{overflowMenuIcon}</SVGIcon>}
      >
        More
      </SidebarNavItem>
    </PopOver>
  );
};

export default SidebarSettingsNavItem;
